export const WhalePositionEvent = {
  WhaleCardView: 'whale_card_view',
  WhaleCardClick: 'whale_card_click',
} as const;

export interface WhalePositionEventDataType {
  [WhalePositionEvent.WhaleCardView]: {
    position_size_usdt: number;
    symbol: string;
    position: string;
    whale_type: string;
  };
  [WhalePositionEvent.WhaleCardClick]: {
    position_size_usdt: number;
    symbol: string;
    position: string;
    whale_type: string;
  };
}
